import React, { Suspense, useEffect, useMemo, useState } from 'react';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { InvoiceProposalsAtom, userInformationAtom } from '../../../Services/_states';
import { useRecoilState, useRecoilValue, useRecoilValueLoadable } from 'recoil';
import { dateFormate, generateFilterKey } from '../../../utils/helper';
import { useNavigate } from 'react-router';
import useDebounce from '../../Shared/Delay/index.tsx';
import { fetchInvoiceProposalsSelector } from '../../../Services/_states/CampaignPlanning/fetchInvoiceProposalsSelector.ts';
import HomeIcon from '@mui/icons-material/Home';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import DynamicBreadcrumbs from '../../Shared/Breadcrumb/index.tsx';
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import Pagination from '../../FlowBuilder/Common/Pagination/index.tsx';
import ViewCommentModal from '../ViewCommentModal.tsx';
import { DecisionBoardActions } from '../../../Services/_actions/index.js';
import { Modal, TextField } from '@mui/material';
import CampaignAssignModal from './CampaignAssignModal.tsx';
import DeclineHoldModal from './DeclineHoldModal.tsx';
import { Link } from 'react-router-dom';
import { set } from 'date-fns';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const CampaignDecisionBoard = () => {
  const navigate = useNavigate();
  const DecisionBoard = DecisionBoardActions();
  const loggedInUser = useRecoilValue(userInformationAtom);
  const [tableState, setTableState] = useRecoilState(InvoiceProposalsAtom);
  const fetchedData = useRecoilValueLoadable(fetchInvoiceProposalsSelector);
  const [selectedCampaign, setSelectedCampaign] = useState({});
  const [searchQuery, setSearchQuery] = useState(tableState?.filters?.search || '');
  const debouncedSearch = useDebounce(searchQuery, 500);
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [declineHoldModal, setDeclineHoldModal] = useState({ show: false, type: '' });
  const [proposalData, setProposalData] = useState({});
  const [showHideAssignModal, setShowHideAssignModal] = useState({ open: false, isUnassignUser: false });

  const convertCampaignToProposal = async (proposal) => {
    await DecisionBoard.converCampaignToProposal(proposal);
    setDeclineHoldModal({ show: true, type: 'Decline' });
  };
  const convertProposalToCampaign = async (proposal) => {
    await DecisionBoard.convertProposalToCampaign(proposal);
    setProposalData(proposal);
    setShowHideAssignModal({ open: true, isUnassignUser: false });
  };

  const convertCampaignOnHold = async (proposal) => {
    await DecisionBoard.convertCampaignOnHold(proposal);
    setDeclineHoldModal({ show: true, type: 'Hold' });
  };

  useEffect(() => {
    if (fetchedData.state === 'hasValue' && !fetchedData.contents.fromCache) {
      const filterKey = generateFilterKey(tableState.filters);
      setTableState((prev) => ({
        ...prev,
        cache: { ...prev.cache, [filterKey]: fetchedData.contents.data },
        totalCountCache: { ...prev.totalCountCache, [filterKey]: fetchedData.contents.totalCount },
      }));
    }
  }, [fetchedData, setTableState]);

  useEffect(() => {
    setTableState((prev) => ({
      ...prev,
      cache: {},
    }));
  }, []);

  useEffect(() => {
    if (debouncedSearch !== tableState.filters.search) {
      setTableState((prev) => ({
        ...prev,
        filters: {
          ...prev.filters,
          search: debouncedSearch,
          page: 0,
        },
        cache: {},
      }));
    }
  }, [debouncedSearch, setTableState]);

  const breadcrumbsData = [
    {
      label: (
        <IconButton color="primary">
          <HomeIcon />
        </IconButton>
      ),
      onClick: () => navigate('/'),
    },
    { label: 'Business Service Decision Board' },
  ];

  const handleSearch = (query) => {
    setSearchQuery(query);
  };
  const handleChangePage = (event, newPage) => {
    setTableState((prev) => ({
      ...prev,
      filters: { ...prev.filters, page: newPage },
    }));
  };

  const handleChangeRowsPerPage = (event) => {
    const value = parseInt(event.target.value, 10) || 10;
    setTableState((prev) => ({
      ...prev,
      filters: { ...prev.filters, limit: value, page: 0 },
    }));
  };

  const handleClickEdit = (rowData) => {
    const proposalId = rowData?.proposal?.proposal_id;
    if (proposalId) {
      navigate(`/r/campaign/edit/${proposalId}`);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'index',
        header: 'S.No',
        // Cell: ({ row }) => row.index + 1,
        enableSorting: false,
        size: 50,
        Cell: ({ row, table }) => {
          const rowIndex = row.index;
          const page = tableState?.filters?.page;
          return page * tableState?.filters?.limit + rowIndex + 1;
        },
      },
      // {
      //   accessorKey: 'proposal.proposal_id',
      //   header: 'Proposal Id',
      //   size: 60,
      // },
      {
        accessorKey: 'proposal.proposal_id',
        header: 'Business Service Id',
        size: 60,
        Cell: ({ row }) => {
          const proposalId = row.original?.proposal?.proposal_id;
          return (
            <Link
              to={`/r/management/proposal-summary/${proposalId}`}
              style={{
                color: 'blue',
                cursor: 'pointer',
                textDecoration: 'none',
              }}
            >
              {proposalId || 'N/A'}
            </Link>
          );
          // Cell: ({ row }) => {
          //   const navigate = useNavigate();
          //   const proposalId = row.original?.proposal?.proposal_id;

          //   return (
          //     <Typography
          //       variant="body2"
          //       sx={{
          //         color: 'blue',
          //         cursor: 'pointer',
          //         textDecoration: 'underline',
          //         overflow: 'hidden',
          //         textOverflow: 'ellipsis',
          //         whiteSpace: 'nowrap',
          //         maxWidth: '100%',
          //       }}
          //       onClick={() => navigate(`/r/${proposalId}/showcurrentproposal`)}
          //     >
          //       {proposalId || 'N/A'}
          //     </Typography>
          //   );
          // }
        },
      },
      {
        accessorKey: 'proposal.name',
        header: 'Business Service Name',
        size: 50,
      },

      {
        accessorKey: 'account',
        header: 'Business Service For',
        size: 50,
      },
      {
        accessorKey: 'assignment_detail?.[0]?.assigned_by ',
        header: 'Created By',
        Cell: ({ row }) => row.original?.assignment_detail?.[0]?.assigned_by || 'N/A',
        size: 60,
      },
      {
        accessorKey: 'proposal.invoice_number',
        header: 'Invoice Number',
        size: 60,
      },
      {
        header: 'Start Date',
        size: 60,
        Cell: ({ row }) => dateFormate(row.original?.proposal?.tentative_start_date, 'DD-MM-YYYY'),
      },
      {
        accessorKey: 'create_campaign',
        header: 'Create Business Service',
        enableSorting: false,
        size: 80,
        Cell: ({ row }) => {
          const [value, setValue] = useState(row.original?.proposal?.campaign_state || '');
          const startDateMissing = !row.original?.proposal?.tentative_start_date;

          const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const selected = event.target.value;
            setValue(selected);

            if (selected === 'PTC') {
              convertProposalToCampaign(row.original);
            } else if (selected === 'PNC') {
              convertCampaignToProposal(row.original);
            } else if (selected === 'POH') {
              convertCampaignOnHold(row.original);
            }
          };

          return (
            <FormControl component="fieldset">
              <RadioGroup
                aria-label={`create-campaign-${row.index}`}
                name={`create-campaign-${row.index}`}
                value={value}
                onChange={handleChange}
                row
              >
                <Tooltip
                  title={startDateMissing ? 'Please fill the Start Date before accepting.' : ''}
                >
                  <span>
                    <FormControlLabel
                      value="PTC"
                      control={
                        <Radio
                          size="small"
                          disabled={startDateMissing}
                          onClick={() => {
                            if (value === 'PTC') {
                              convertProposalToCampaign(row.original);
                            }
                          }}
                        />
                      }
                      label="Accept"
                    />
                  </span>
                </Tooltip>

                <FormControlLabel value="PNC" control={<Radio size="small" />} label="Decline" />
                <FormControlLabel value="POH" control={<Radio size="small" />} label="OnHold" />
              </RadioGroup>
            </FormControl>
          );
        },
      },
      {
        header: 'Assigned To',
        size: 60,
        enableSorting: false,
        Cell: ({ row }) => {
          const assignments = row.original?.assignment_detail || [];

          if (assignments.length === 0) return 'N/A';

          const names = assignments
            .map((item) => item?.assigned_to?.assigned_to_name)
            .filter(Boolean);

          return (
            <div>
              {names.map((name, index) => (
                <div key={index}>{name}</div>
              ))}
            </div>
          );
        },
      },
      {
        accessorKey: 'proposal.type_of_end_customer_name',
        header: 'Type of End Customer',
        enableSorting: false,
        size: 90,
      },
      {
        accessorKey: 'action',
        header: 'Action',
        enableSorting: false,
        size: 50,
        Cell: ({ row }: any) => {
          const [anchorEl, setAnchorEl] = useState < null | HTMLElement > (null);
          const open = Boolean(anchorEl);

          const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget);
          };

          const handleClose = () => {
            setAnchorEl(null);
          };

          return (
            <Box>
              <IconButton onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id={`menu-${row.index}`}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': `menu-button-${row.index}`,
                }}
              >
                <MenuItem
                  onClick={() => {
                    setSelectedCampaign(row.original);
                    setOpenCommentModal(true);
                    setAnchorEl(null);
                  }}
                >
                  Comment
                </MenuItem>
                <MenuItem onClick={() => {setShowHideAssignModal({ open: true, isUnassignUser: true }), setProposalData(row.original)}}>Unassign User</MenuItem>
                <MenuItem onClick={() => handleClickEdit(row.original)}>Edit Details</MenuItem>
              </Menu>
            </Box>
          );
        },
      },
    ],
    [tableState]
  );

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '5px' }}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(e, item) => item?.onClick?.()}
      />

      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            Business Service Decision Board
          </Typography>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{ alignItems: 'center', paddingTop: '8px', paddingBottom: '8px' }}
        >
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 2,
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <SearchBox handleSearch={handleSearch} value={searchQuery} />
            </Box>
            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 'auto' }}>
              <Button variant="outlined" onClick={() => { console.log("clear") }}>Clear</Button>
            </Box> */}
          </Grid>
        </Grid>
      </Grid>

      <CommonTable
        columns={columns}
        data={tableState.cache[generateFilterKey(tableState.filters)] || []}
        state={{ isLoading: fetchedData.state === 'loading' }}
        muiTableContainerProps={{
          sx: {
            height: 'calc(100vh - 300px)',
            width: '100%',
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '6px',
            },
          },
        }}
        renderBottomToolbar={() => (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Pagination
              totalCount={tableState.totalCountCache[generateFilterKey(tableState.filters)] || 0}
              rowsPerPage={tableState?.filters?.limit}
              page={tableState?.filters?.page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Box>
        )}
      />
      <Suspense fallback={<div>Loading...</div>}>
        {openCommentModal && (
          <ViewCommentModal
            open={openCommentModal}
            onClose={() => setOpenCommentModal(false)}
            campaign={selectedCampaign}
          />
        )}
      </Suspense>
      <CampaignAssignModal
        open={showHideAssignModal?.open}
        isUnassignUser={showHideAssignModal?.isUnassignUser ?? false}
        onClose={(e, status) => {
          setShowHideAssignModal({ open: false, isUnassignUser: false });
          if (status === 'success') {
            setTableState((prev) => ({
              ...prev,
              cache: {},
            }));
          }
        }}
        proposalData={proposalData}
      />

      <DeclineHoldModal
        declineHoldModal={declineHoldModal}
        setDeclineHoldModal={setDeclineHoldModal}
      />
    </Box>
  );
};

export default CampaignDecisionBoard;
